import { client } from '@generated/works-api/proxy/client.gen';

// throwOnError:true (set in openapi-ts.config.ts) makes the client throw the
// parsed response *body* on non-2xx — which carries no HTTP status of its own.
// This handler grafts the status onto that thrown value so handleApiError()
// can route by status code. Without it every HTTP error looks statusless.
// Primitive bodies (non-JSON error responses) are returned untouched and will
// be treated as statusless by consumers, since a status cannot be stuck to a
// primitive without throwing in strict mode.
// Exported so the spec can exercise the shipping handler directly.
export const attachStatusToError = (error: unknown, response?: Response) => {
  if (response?.status && typeof error === 'object' && error !== null) {
    (error as { status?: number }).status = response.status;
  }
  return error;
};

client.interceptors.error.use(attachStatusToError);
